import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { PODocType } from "../../models/FDropdown";

export interface IForm {
    open: boolean;
    singleData: any;
    reload: boolean;
    setReload: React.Dispatch<React.SetStateAction<boolean>>;
    hideDialog: () => void;
    toast: any;
}

const schema = yup.object({
    document_Type: yup.string().required("Select Document Type"),

    document_Name: yup.string()
        .required("Document Name is required")
        .test("match-type", function (value) {

            const { document_Type } = this.parent;

            if (!value || !document_Type) return true;

            const name = value.trim();
            if (document_Type === "Client") {
                if (!/^Client\s.+/.test(name)) {
                    return this.createError({  message: 'Must start with "Client " (C capital + space)' });
                }
            }
            else if (document_Type === "Vendor") {
                if (!/^Vendor\s.+/.test(name)) {
                    return this.createError({ message: 'Must start with "Vendor " (V capital + space)' });
                }
            }

            else if (document_Type === "Consultant") {
                if (name.includes("Client") || name.includes("Vendor")) {
                    return this.createError({  message: 'Consultant document cannot contain "Client" or "Vendor"'
                    });
                }
            }
            return true;
        })
});

export const Form = ({
    open,
    singleData,
    setReload,
    hideDialog,
    toast
}: IForm) => {

    const { control, handleSubmit, reset, watch } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            document_Name: "", document_Type: ""
        }
    });

    const docType = watch("document_Type");

    useEffect(() => {
        if (singleData) {
            reset({
                document_Name: singleData.document_Name || "",
                document_Type: singleData.document_Type || ""
            });
        }
    }, [singleData, reset]);

    const onSubmit = async (data: any) => {
        const isEdit = !!singleData?.document_ID;

        const url = isEdit
            ? `ApwDocument_Mast/updateDocument/${singleData.document_ID}`
            : "ApwDocument_Mast/addDocument";

        const method = isEdit ? "PUT" : "POST";
        const payload = {
            ...data,
            valcal: 500
        };

        const response = await Fetch(url, method, payload, null, toast);

        if (response) {
            toast.current?.show({
                severity: "success",
                summary: "Success",
                detail: isEdit ? "Updated Successfully" : "Added Successfully",
                life: 3000
            });

            setReload(prev => !prev);
            hideDialog();
        }
    };

    return (

        <Dialog
            visible={open} onHide={hideDialog} header="Add / Edit Document" modal
            style={{ width: "32vw" }}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">

                <div className="field mr-10px gap-2">
                    <JVDropdown
                        required column={1.5}
                        label="Document Type"
                        control={control}
                        name="document_Type"
                        options={PODocType}
                        optionLabel="name"
                        optionValue="name"
                        placeholder="Select Document Type"
                    /> </div>

                <div className="field ml-3">
                    <label className="font-medium block mb-2">
                        Document Name <span className="text-red-500">*</span>
                    </label>

                    <Controller
                        name="document_Name"
                        control={control}
                        render={({ field, fieldState }) => (
                            <>
                                <InputText
                                    {...field}
                                    placeholder="Enter Document Name"
                                    className={`w-22rem ${fieldState.error ? "p-invalid" : ""}`}
                                />
                                {fieldState.error && (
                                    <small className="p-error block mt-1">
                                        {fieldState.error.message}
                                    </small>
                                )}
                            </>
                        )}
                    />
                </div>
                <div className="flex justify-content-end gap-2 mt-4">
                    <Button label="Save" type="submit" />
                    <Button label="Close" type="button" className="p-button-outlined" onClick={hideDialog}
                    />
                </div>
            </form>
        </Dialog>
    );
};
